import { render, staticRenderFns } from "./InfeedManagementFormGroup.vue?vue&type=template&id=30b8d922&"
import script from "./InfeedManagementFormGroup.vue?vue&type=script&lang=ts&"
export * from "./InfeedManagementFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports